import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Panel from './panel'
import TeamInfo from './forms/team-info'
import MemberInfo from './forms/member-info'
import PaymentSection from './payment-section'
import Summary from './summary'
import { postForm } from '../../ajax'

function Registration({token, league, type, player, paymentParams}) {
  const [team, setTeam] = useState()
  const [member, setMember] = useState()
  const [payment, setPayment] = useState()
  const [formData, setFormData] = useState()
  const [step, setStep] = useState('Info')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const leaguePrice = parseFloat(type == 'team' ? league.team_price : league.individual_price)
  const steps = leaguePrice ? ['Info', 'Payment', 'Summary'] : ['Info', 'Summary']
  const isInfoStep = step == 'Info'
  const isPaymentStep = step == 'Payment'
  const isSummaryStep = step == 'Summary'
  const leagueName = league.full_name.toUpperCase()

  const infoForm = () => {
    if (type == 'team') return <TeamInfo
      token={token}
      league={league}
      type={type}
      player={player}
      team={team}
      onComplete={onTeamComplete}
    />
    else return <MemberInfo 
      token={token}
      league={league}
      type={type}
      player={player}
      member={member}
      onComplete={onMemberComplete}
    />
  }

  const onTeamComplete = (teamData, formData) => {
    if (!leaguePrice) return createRegistration(formData)

    setTeam(teamData)
    setFormData(formData)
    setStep('Payment')
  }

  const onMemberComplete = (memberData, formData) => {
    if (!leaguePrice) return createRegistration(formData)

    setMember(memberData)
    setFormData(formData)
    setStep('Payment')
  }

  const createRegistration = async (formData) => {
    setLoading(true)
    const response = await postForm(`/plugin/leagues/${league.id}/registrations`, formData)
    const json = await response.json()
    setLoading(false)
    if (json.error) setError(json.error)
    else setStep('Summary')
  }

  const onPaymentComplete = async (data) => {
    setPayment(data)
    setStep('Summary')
  }
  
  return <div className={'row registration-content' + (loading ? ' isLoading' : '')}>
    <span className='col-xs-12 league-name-small mobile-only'>{leagueName}</span>
    <span className='col-xs-12 league-name desktop-only'>{leagueName}</span>
    <div className='col-xs-12'>
      <Panel steps={steps} currentStep={step} />
      { loading && <div className='animated-spinner'></div> }
      { error && <div className='registration-error'>{error}</div> }
      { isInfoStep && infoForm() }
      { isPaymentStep && 
        <PaymentSection 
          league={league}
          token={token}
          type={type}
          paymentParams={paymentParams}
          cards={player.cards}
          defaultCard={player.default_payment_method}
          formData={formData}
          onBack={() => setStep('Info')}
          onComplete={onPaymentComplete}
        />
      }
      { isSummaryStep && 
        <Summary
          league={league}
          type={type}
          token={token}
          payment={payment}
        />
      }
    </div>
  </div>
}

Registration.propTypes = {
  token: PropTypes.string.isRequired,
  league: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  player: PropTypes.object.isRequired,
  paymentParams: PropTypes.object.isRequired,
}

export default Registration
